const light = '#f4f4f4'
const primary = '#F85F33'
const secondary = '#594BAA'
const warning = '#EED4C7'
const info = '#8C416A'

const colors = {
  light,
  primary,
  secondary,
  warning,
  info
}
export default colors
